module.exports = __webpack_public_path__ + "static/img/courier-map-marker-ready.1a7b3715.svg";